import { UserLocale } from "@outschool/gql-backend-generated";
import React from "react";
import { BASE_LOCALE, SupportedLocale } from "../constants";

const LocaleContext = React.createContext<SupportedLocale>(UserLocale.En);

export const LocaleProvider = ({
  children,
  userSelectedLocale = BASE_LOCALE,
}: React.PropsWithChildren<{
  userSelectedLocale?: SupportedLocale;
}>) => (
  <LocaleContext.Provider value={userSelectedLocale}>
    {children}
  </LocaleContext.Provider>
);

export const useLocale = () => React.useContext(LocaleContext);
